<template>
  <div class="midbg">
    <div class="container">
      <div class="detailcontent">
        <div class="h100"></div>
        <div class="playimg">
          <div class="playicon" @click="play(listenMode)"></div>
        </div>
        <img
          class="faceImg"
          :src="listenMode.faceImgPlay | objs"
          @click="play(listenMode)"
        />

        <p class="f26">{{ listenMode.bookName }}</p>
        <p class="f16">[{{ listenMode.nationName }}] {{ listenMode.author }}</p>
        <p class="f16">{{ listenMode.slogan }}</p>
        <p>
          <span class="f16 w200">{{ listenMode.listenNum }}已听</span>
          <!-- <span class="ludubi">{{ listenMode.priceTag }}</span> -->

       <!--   <button class="buyBtn" @click="$store.commit('showVipQrcode')">
            开通VIP会员
          </button> -->
        </p>
      </div>
      <div class="detailcontent">
        <div class="line"></div>
      </div>
      <div class="detailcontent">
        <div class="f20">
          分节收听<span class="f16"> 总时长：{{ listenMode.totalSec }}</span>
        </div>
        <div
          class="zhangjie"
          v-for="(item, index) in listenMode.sectionList"
          :key="index"
        >
          <div
            @click="playthis(index, listenMode)"
            :class="
              bookIndex == index && $store.state.isPlay
                ? 'on'
                : index == 0 && listenMode.needBuy == 2
                ? 'trylisten'
                : ''
            "
          >
            第{{ index + 1 }}节 {{ item.title
            }}<span
              v-if="listenMode.needBuy == 2 && index !== 0"
              class="lock"
            ></span>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="detailcontent">
        <div class="f20" v-if="listenMode.anchorTeam != ''">本书解读团队</div>
        <div v-for="item in listenMode.anchorTeam" :key="item.id">
          <div class="w25">
            <router-link :to="{ path: '/anchorinfo', query: { id: item.id } }">
              <img :src="item.face | objs" class="anchorImg" />
              <p>{{ item.name }}</p>
              <div>{{ item.roleStyleName }}</div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="detailcontent">
        <div class="tab">
          <button :class="showtext ? 'active' : 'cursor'" @click="showpinlun(2)">
            节目简介
          </button>
          <button :class="showtext ? 'cursor' : 'active'" @click="showpinlun(1)">
            书友评论
          </button>
          <div class="pinlunBtn cursor" @click="writePl">发表评论</div>
        </div>
        <div v-if="showtext">
          <div class="f20" v-if="listenMode.about">节目简介</div>
          <div class="about" v-html="listenMode.about"></div>
          <p><br /></p>
          <div class="f20" v-if="listenMode.goldWord">本书金句</div>
          <div class="about" v-html="listenMode.goldWord"></div>
          <p><br /></p>
          <div v-if="listenMode.needBuy == 1">
            <div class="f20" v-if="listenMode.content">本书内容</div>
            <div class="about" v-html="listenMode.content"></div>
            <p><br /></p>
          </div>
          <div class="f20" v-if="listenMode.relatedBooks != ''">相关推荐</div>
          <div
            class="about"
            v-for="(item, index) in listenMode.relatedBooks"
            :key="index" >
			<tui-jian-list :books="item"></tui-jian-list> 
          </div>
        </div>
        <div v-else>
          <div v-if="reviewList">
            <div class="pinlunlist">
              <div v-for="item in reviewList" :key="item.id">
                <div class="pinlunList">
                  <div class="shuyou">
                    <img :src="item.face | objs" />
                  </div>
                  <div class="comment">
                    <span> {{ item.name }} </span>
                    {{ item.comment }}
                  </div>
                  <div class="dianzan">
                    <button class="smallBtn cursor" @click="rePly(item.id, item.name)">
                      回复
                    </button>
                    <div class="zan" v-if="item.isFavour == 2">
                      <span>{{ item.favourNum }} </span>
                      <img class="cursor"
                        @click="zanDel(item.id)"
                        src="https://objs.auto-learning.com/xcximages/icon_dianzan_blue.png"
                      />
                    </div>
                    <div class="zan" v-else>
                      <span>{{ item.favourNum }} </span>
                      <img class="cursor"
                        @click="zanAdd(item.id)"
                        src="https://objs.auto-learning.com/xcximages/icon_dianzan_gray.png"
                      />
                    </div>

                    <button
                      class="smallBtn cursor"
                      v-if="item.isSelf == 2"
                      @click="commentDel(item.id)"
                    >
                      删除
                    </button>
                    <p>{{ item.createTime }}</p>
                  </div>

                  <div v-if="item.replyNum > 0">
                    <div class="reply">
                      <div class="top">▲</div>
                      <div v-for="item in item.replyList" :key="item.replyId">
                        <div class="replyList">
                          {{ item.userName }}: {{ item.reply }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pinlunline"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="h100"></div>
          <div  v-if="showwrite">
            <div class="login-container">  
              <div class="pinlunbg">
                  <div class="f20">发表评论</div>
                  <textarea class="inputpinglun" 
                  type="text"
                  :placeholder="replytips"
                  v-model="comment" > </textarea>
                <button class="pinlun-btn send cursor" @click="send">发表评论</button>
                <button class="pinlun-btn cursor" @click="changeshow">取消</button>
               
              </div>     
            </div>
            <div class="blackbg" @click="changeshow"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TuiJianList from "@/components/TuiJianList.vue";
import { getCookie } from "@/network/cookie.js";
export default {
  metaInfo() {
    return {
      title: this.listenMode.bookName + "--" + this.listenMode.slogan,
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "路上畅听是一款现代化的移动学习产品，开小车、坐地铁、搭公交，一路听书是最好的选择，让用户的无聊碎片的时间变成力量与财富，来自最畅销书籍TOP100的有声书，15分钟读尽好书精华。横跨商业、科技、哲学、文史等优质内容，增长你的知识与技能，音频可听文字可视，任君挑选。",
        },
        {
          vmid: "keywords",
          name: "keywords",
          content:
            "车载FM,最畅销书籍TOP100,回声阅读,路上畅听FM,广播电台,一路听书,名人演讲,听演讲学英文,高清音频电台,儿童故事,微图书,free book,reading on the way",
        },
      ],
    };
  },
  data() {
    return {
      listenMode: {
        bookName: "路上畅听",
        sLogan: "一个专听国际书籍的APP,珠海动听科技有限公司", 
      },
      reviewList: {},
      replytips: "发表评论",
      comment: "",
      showtext: true,
      showwrite: false,
      bookId: this.$route.query.bookId,
      bookIndex:
        this.$store.state.trackQueue.length > 0
          ? this.$route.query.bookId ==
            this.$store.state.trackQueue[this.$store.state.trackIndex].bookId
            ? this.$store.state.bookIndex
            : -1
          : -1,
    };
  },
  components: {
	TuiJianList
  },
  methods: {
    getListenMode: function () {
      const url =
        "xcx/listen-mode?bookId=" +
        this.bookId +
        "&sessionId=" +
        getCookie("sessionId");

      this.$http.get(url).then((res) => {
        if (res.data.meta.success) {
          this.listenMode = res.data.data
		if(!res.data.data.about){
			this.showtext = false;
			}
        } else {
          this.$router.push({ path: "/Home" });
        }
      });
    },
    getreviewList: function () {
      const sessionId = getCookie("sessionId");
      this.$http
        .get("/xcx/book-review-list?bookId=" + this.bookId+"&hasReply=2&sessionId="+sessionId)
        .then((res) => {
          if (res.data.meta.success) {
            this.reviewList = res.data.data;
          }
        });
    },
    commentDel:function(id){
      const sessionId = getCookie("sessionId");
      const params = new FormData()
            params.append('sessionId', sessionId)
            params.append('commentId', id)
            params.append('bookId', this.bookId) 
            axios.post('//api.auto-learning.com/v3/xcx/book-comment-del', params).then(res => {
                if(res.data.meta.success){ 
                  this.getreviewList(); 
                }else{
                  alert(res.data.meta.message) 
                } 
            }) 
            
    },
    zanAdd:function(id){
      const sessionId = getCookie("sessionId");
      const params = new FormData()
            params.append('sessionId', sessionId)
            params.append('commentId', id) 
            axios.post('//api.auto-learning.com/v3/xcx/comment-favour', params).then(res => {
                if(res.data.meta.success){ 
                  this.getreviewList(); 
                }else{
                  alert(res.data.meta.message) 
                } 
            }) 
    },
     zanDel:function(id){
      const sessionId = getCookie("sessionId");
      const params = new FormData()
            params.append('sessionId', sessionId)
            params.append('commentId', id) 
            axios.post('//api.auto-learning.com/v3/xcx/comment-favour-del', params).then(res => {
                if(res.data.meta.success){ 
                  this.getreviewList(); 
                }else{
                  alert(res.data.meta.message) 
                } 
            }) 
    },
    writePl: function () {
      this.showwrite = true;
      this.showtext = false;
      this.replyId = "";
      this.replyName = "";
      this.replytips = "发表评论...";
    },
    changeshow:function(){
      this.showwrite = !this.showwrite;
    },
    showpinlun: function (e) {
      if (e == 2) {
        this.showtext = true;
      } else {
        this.showtext = false;
      }
    },
    send:function(){
       if (getCookie('sessionId')) {
                this.sessionId = getCookie('sessionId');
            } else{
              this.changeshow();
              this.$store.commit('showLogin');
              return
            } 
      if (this.replyId == '' || this.replyId == undefined) {
          const params = new FormData()
            params.append('sessionId', this.sessionId)
            params.append('comment', this.comment)
            params.append('bookId', this.bookId)
            params.append('hasReply',1)
            axios.post('//api.auto-learning.com/v3/xcx/comment-submit', params).then(res => {
                if(res.data.meta.success){
                  this.comment = "";
                  this.getreviewList(); 
                }else{
                  alert(res.data.meta.message) 
                }
                this.changeshow();
            }) 
      }else{
        const params = new FormData()
            params.append('sessionId', this.sessionId)
            params.append('reply', this.comment)
            params.append('commentId', this.replyId)
            params.append('replyUser',this.replyName)
            params.append('hasReply',2)
            axios.post('//api.auto-learning.com/v3/xcx/comment-reply-add', params).then(res => {
                if(res.data.meta.success){
                  this.comment = "";
                  this.getreviewList(); 
                }else{
                  alert(res.data.meta.message) 
                }
                this.changeshow();
            }) 
      }
    },
    rePly:function(rid,rname){
      this.replyId=rid;
        this.replyName=rname;
        this.replytips = '回复' + rname + '...';
        this.showwrite=true;
    },
    play(item) {
      this.$store.commit("addQueue", item);
      this.$store.dispatch("getMusicUrl");
      this.bookIndex = 0;
    },
    playthis(i, item) {
      this.$store.commit("addQueue", item);
      this.bookIndex = i;
      this.$store.state.bookIndex = i;
      this.$store.dispatch("getMusicUrl");
    },
  },
  watch: {
    $route() {
      this.bookId = this.$route.query.bookId;
      this.getListenMode();
    },
    "$store.state.bookIndex"() {
      if (
        this.bookId ==
        this.$store.state.trackQueue[this.$store.state.trackIndex].bookId
      ) {
        this.bookIndex = this.$store.state.bookIndex;
      }
    },
  },
  mounted() {
    if (this.$route.query.bookId) {
      this.bookId = this.$route.query.bookId;
    }
    this.getListenMode();
    this.getreviewList();
  },
};
</script>

<style scoped>
a {
  color: #2c3e50;
  text-decoration: none;
}
p {
  margin: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.midbg {
  background: rgba(249, 249, 249, 1);
  margin: 0;
  padding: 0;
}

.detailcontent {
  padding: 0 100px 50px 100px;
  background: #ffffff;
  overflow: hidden;
}
.detailcontent:hover .playimg {
  display: block;
}
.playimg {
  position: relative;
  z-index: 0;
  display: none;
}

.playimg .playicon {
  position: absolute;
  top: 65px;
  left: 65px;
  width: 60px;
  height: 60px;
  background-image: url(../assets/play.png);
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  opacity: 1;
  z-index: 1;
}

.playimg .playicon:hover {
  opacity: 0.7;
}

.playimg .pause {
  position: absolute;
  top: 0;
  left: 0;
  width: 190px;
  height: 190px;
  background-image: url(../assets/pause.png);
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  opacity: 0.9;
  z-index: 1;
}

.faceImg {
  width: 190px;
  height: 190px;
  float: left;
  margin-right: 30px;
  cursor: pointer;
}

.f26 {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(36, 41, 38, 1);
  line-height: 60px;
}

.f20 {
  font-size: 20px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  color: rgba(36, 41, 38, 1);
  margin-bottom: 10px;
}

.f16 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(155, 166, 166, 1);
}

.w200 {
  width: 200px;
  float: left;
}

.ludubi {
  padding-right: 65px;
  margin-right: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(155, 166, 166, 1);
  height: 22px;
  background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
  background-position: right top;
  background-repeat: no-repeat;
  background-size: 65px 18px;
  display: inline-block;
}

.buyBtn {
  padding: 5px 20px;
  background: rgba(75, 204, 170, 1);
  border-radius: 2px;
  float: right;
  color: #ffffff;
  border: 1px solid rgba(75, 204, 170, 1);
  cursor: pointer;
  margin-left: 20px;
}
.buyBtn:hover {
  background: rgb(23, 196, 150);
}
.line {
  margin: 50px 0;
  height: 1px;
  background-color: rgba(242, 244, 243, 1);
}

.zhangjie {
  padding: 10px 0;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(155, 166, 166, 1);
  cursor: pointer;
}
.lock {
  width: 22px;
  height: 22px;
  float: right;
  background-image: url("../assets/lock.png");
  background-size: 22px;
  background-repeat: no-repeat;
  background-position: center right;
}
.zhangjie:hover {
  color: #2c3e50;
}
.on {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #4cccaa;
  background-image: url("../assets/playing.png") !important;
  background-size: 22px;
  background-repeat: no-repeat;
  background-position: center right;
}
.trylisten {
  background-image: url("../assets/trylisten.png") !important;
  background-size: 47px 22px;
  background-repeat: no-repeat;
  background-position: center right;
}
.about {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(1, 1, 1, 1);
  line-height: 32px;
}

.h100 {
  height: 100px;
}
.anchorImg {
  border: 1px;
  border-radius: 40px;
  width: 80px;
  height: 80px;
}
.w25 {
  width: 150px;
  float: left;
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
}
.w25 p {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

/*评论*/

.pinlunList {
  margin: 5px;
  overflow: hidden;
  font-size: 16px;
  padding-top: 5px;
}

.pinlunList .shuyou {
  height: 35px;
  margin-bottom: 5px;
  line-height: 35px;
  width: 70px;
  float: left;
}

.pinlunList .shuyou img {
  width: 60px;
  height: 60px;
  border: 1px;
  border-radius: 30px;
  margin: 2px 2px 2px 7px;
  float: left;
}

.pinlunList .comment span {
  height: 20px;
  display: block;
  color: #aab0af;
  font-size: 12px;
}

.pinlunList .comment {
  padding-left: 10px;
  padding-right: 10px;
  line-height: 120%;
  width: 800px;
  float: left;
  color: #323433;
  font-size: 15px;
}

.pinlunList .dianzan {
  padding-left: 50px;
  font-size: 12px;
  color: #999;
  margin: 5px 0;
  clear: both;
}

.pinlunList .dianzan span {
  width: 60px;
  float: right;
}
.pinlunList p {
  padding-left: 20px;
}
.huifu {
  color: #323433;
}
.smallBtn {
  border: 1px solid #aab0af;
  color: #aab0af;
  float: right;
  border-radius: 3px;
  background: #ffffff;
}
.pinlunList .reply { 
  width: 80%;
  background: #f8f8f8;
  border: 1px;
  border-radius: 3px;
  margin: 10px 20px 10px 80px;
  position: relative;
}

.pinlunList .reply .top {
  color: #f8f8f8;
  width: 100%;
  clear: both;
  font-size: 20px;
  position: absolute;
  top: -15px;
  left: 5px;
}

.pinlunList .reply .replyList {
  padding: 7px 10px 7px 10px;
  font-size: 14px;
  color: #5a5a5a;
}

.zan {
  float: right;
  padding-right: 25px;
  padding-bottom: 10px;
}

.zan img {
  width: 14px;
  height: 14px;
  padding-left: 5px;
  padding-top: 4px;
  padding-right: 10px;
  float: right;
}

.botPannel {
  position: fixed;
  left: 20%;
  right: 20%;
  bottom: 100px;
  background: #fff;
  overflow: hidden;
  height: 45px;
  padding: 5px 10px 0px 10px;
  border-top: 1px solid #e6ebeb;
  display: flex;
  font-size: 12px;
}

.botPannel textarea,
.botPannel input {
  flex: 6;
  font-size: 14px;
  border: 1px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  padding: 5px 5px 5px 10px;
  height: 25px;
  line-height: 25px;
  background: #f1f3f3;
  color: #5a5a5a;
}

.botPannel .button {
  flex: 1;
  text-align: center;
  height: 25px;
  padding: 5px 10px 5px 4px;
  line-height: 25px;
  border-top-right-radius: 17px;
  border-bottom-right-radius: 17px;
  border: 1px;
  background-color: #00d1b0;
  color: #fff;
  font-size: 12px;
}

textarea::-webkit-input-placeholder,
textarea:-moz-placeholder {
  color: #aab0af;
  font-size: 12px;
  line-height: 25px;
}

.pintitle {
  color: #323433;
  font-size: 15px;
  padding: 20px 15px 10px 15px;
}

.pinlunBtn {
  float: right;
  color: #676b6a;
  font-size: 12px;
  width: 70px;
  text-align: center;
  padding: 5px 0 5px 15px;
  border: 1px solid #b6bbba;
  border-radius: 2px;
  background-image: url(https://objs.auto-learning.com/xcximages/bofan_btn_pl.png);
  background-repeat: no-repeat;
  background-size: 13px 13px;
  background-position: 7px center;
}

.pinlunline {
  border-bottom: 1px solid #e6ebeb;
  height: 5px;
}
.tab {
  padding-bottom: 20px;
}
.tab button {
  background: #ffffff;
  border: 1px solid #e6ebeb;
  padding: 10px 20px;
}
.active {
  border: 1px solid #00d1b0 !important;
  background: #00d1b0 !important;
  color: #ffffff;
}
.pinlunbg{background: #ffffff; padding: 30px 30px 60px 30px;}
.inputpinglun{
  width: 98%;
  height: 80px;
  clear: both;
}
.pinlun-btn{
  width: 120px;
  padding: 5px 20px; 
  border:1px solid #e6ebeb;
  float: right;
}
.send{background: #40d1aa; color: #fff; border: 1px solid #4cccaa; margin-left: 20px;}
.pinlun-btn:hover{background: #2c3e50; color: #fff; border: 1px solid #2c3e50;}
.cursor{cursor: pointer;}
</style>
